export default __webpack_public_path__ + "static/media/kira-b50-large.55fcef95.png";